import { __awaiter } from "tslib";
import { isAbsoluteUrl } from '../../../../utils';
import { CONTENT_REPO_ORIGIN, FALLBACK_IATA_CODE } from './constants';
/**
 * Нормализует относительный путь в content repo: trim, без ведущих `/`, без двойных слэшей.
 */
export const normalizeContentRepoPath = (path) => {
    const trimmed = path.trim().replace(/^\/+/, '');
    return trimmed.replace(/\/+/g, '/');
};
/**
 * Собирает абсолютный URL в content repo для уже проверенного относительного пути.
 */
export const buildContentRepoUrl = (path, iataCode) => {
    return `${CONTENT_REPO_ORIGIN}/${iataCode}/${normalizeContentRepoPath(path)}`;
};
/**
 * Резолвит URL для запроса.
 */
export const resolveFetchUrl = (path, contentRepo, iataCode) => {
    const isAbsolute = isAbsoluteUrl(path);
    if (contentRepo && isAbsolute) {
        throw new Error('При contentRepo=true допускаются только относительные пути content repo');
    }
    if (!contentRepo && isAbsolute) {
        return path;
    }
    return buildContentRepoUrl(path, iataCode);
};
/**
 * Собирает массив URL для запроса.
 */
export const getUrlArray = (path, fallback, contentRepo, iataCode) => {
    const primaryUrl = resolveFetchUrl(path, contentRepo, iataCode);
    const fallbackUrl = fallback ? resolveFetchUrl(fallback, contentRepo, FALLBACK_IATA_CODE) : undefined;
    return [primaryUrl, ...(fallbackUrl ? [fallbackUrl] : [])];
};
/**
 * Читает тело ответа в зависимости от типа.
 */
export const readResponseBody = (response, type) => __awaiter(void 0, void 0, void 0, function* () {
    switch (type) {
        case 'json':
            return response.json();
        case 'text':
            return response.text();
        case 'blob':
            return response.blob();
        case 'arrayBuffer':
            return response.arrayBuffer();
        default: {
            const exhaustive = type;
            return exhaustive;
        }
    }
});
/**
 * Загружает данные из URL.
 */
export const loadData = (url, signal, responseType) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(url, { signal });
    if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    return yield readResponseBody(response, responseType);
});
